import styled from '@emotion/styled';
import { colors, fonts, DESKTOP } from '../tokens';

export const SetupContent = styled.div`
  width: 100%;
  max-width: 353px;
  margin: 0 auto;
  padding: 60px 0 24px;
  display: flex;
  flex-direction: column;
  gap: 24px;
  flex: 1 1 auto;

  ${DESKTOP} {
    /* Desktop centres the wizard in a 480px column (Desktop-Experience.png). */
    max-width: 480px;
    padding: 56px 0 24px;
  }
`;

export const SetupHeading = styled.h1`
  font-family: ${fonts.heading};
  font-weight: 400;
  font-size: 30px;
  line-height: 1.2;
  letter-spacing: -0.18px;
  color: ${colors.heading};
  margin: 0;
`;

export const SetupHint = styled.p`
  font-family: ${fonts.body};
  font-weight: 400;
  font-size: 16px;
  line-height: 1.5;
  letter-spacing: -0.096px;
  color: ${colors.muted};
  margin: 0;
`;

export const FieldLabel = styled.label`
  font-family: ${fonts.body};
  font-weight: 600;
  font-size: 16px;
  line-height: 1.5;
  letter-spacing: -0.096px;
  color: ${colors.text};
  display: block;
  margin-bottom: 8px;
`;

export const TextInput = styled.input`
  width: 100%;
  height: 44px;
  border-radius: 23px;
  border: 1px solid ${colors.chipBorder};
  padding: 10px 20px;
  font-family: ${fonts.body};
  font-size: 16px;
  letter-spacing: -0.096px;
  color: ${colors.text};
  background: #fff;
  box-sizing: border-box;

  &::placeholder {
    color: ${colors.muted};
  }

  &:focus {
    outline: none;
    border-color: ${colors.brand};
  }
`;

// "Enter birthdate or due date" — three native selects (MM / DD / YYYY).
export const DateRow = styled.div`
  display: flex;
  gap: 8px;
  width: 100%;
`;

export const DateSelect = styled.select`
  flex: 1 1 0;
  min-width: 0;
  height: 44px;
  border-radius: 23px;
  border: 1px solid ${colors.chipBorder};
  padding: 10px 14px;
  font-family: ${fonts.body};
  font-size: 16px;
  letter-spacing: -0.096px;
  color: ${colors.text};
  background: #fff;
  box-sizing: border-box;

  &:focus {
    outline: none;
    border-color: ${colors.brand};
  }
`;

// "+ Add a new child" on the existing-child picker.
export const TextLink = styled.button`
  appearance: none;
  background: none;
  border: none;
  padding: 10px 0 0;
  cursor: pointer;
  justify-content: center;
  font-family: ${fonts.body};
  font-weight: 600;
  font-size: 16px;
  letter-spacing: -0.096px;
  color: #5E5E5E;
  border-radius: 31px;
border: 1px solid #D1D1D1;
background: var(--Base-White, #FFF);
display: flex;
padding: 12px 18px;
align-items: center;
gap: 8px;
`;

// Pill option rows used by "Baby is a" and "Your relationship to the baby".
export const OptionPill = styled.button`
  appearance: none;
  width: 100%;
  min-height: 44px;
  border-radius: 9999px;
  padding: 10px 20px;
  cursor: pointer;
  font-family: ${fonts.body};
  font-weight: 500;
  font-size: 16px;
  line-height: 1.5;
  letter-spacing: -0.096px;
  text-align: center;
  background: ${props => (props.selected ? colors.chipsPanelBg : '#fff')};
  border: 1px solid ${props => (props.selected ? colors.brand : colors.chipBorder)};
  color: ${colors.text};
`;

export const OptionList = styled.div`
  display: flex;
  flex-direction: column;
  gap: 10px;
  width: 100%;
`;

// Larger left-aligned cards for "Who is creating this book?".
export const ChoiceCard = styled.button`
  appearance: none;
  width: 100%;
  text-align: left;
  border-radius: 10px;
  padding: 14px 16px;
  cursor: pointer;
  background: ${props => (props.selected ? colors.chipsPanelBg : '#fff')};
  border: 1px solid ${props => (props.selected ? colors.brand : colors.chipBorder)};
  display: flex;
  flex-direction: column;
  gap: 4px;
`;

export const ChoiceTitle = styled.span`
  font-family: ${fonts.body};
  font-weight: 600;
  font-size: 16px;
  line-height: 1.5;
  letter-spacing: -0.096px;
  color: ${colors.text};
`;

export const ChoiceCopy = styled.span`
  font-family: ${fonts.body};
  font-weight: 500;
  font-size: 14px;
  line-height: 1.5;
  letter-spacing: -0.084px;
  color: ${colors.muted};
`;
